import { render, staticRenderFns } from "./ConfigurationSubject.vue?vue&type=template&id=7c8a2c60&scoped=true"
import script from "./ConfigurationSubject.vue?vue&type=script&lang=js"
export * from "./ConfigurationSubject.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationSubject.vue?vue&type=style&index=0&id=7c8a2c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8a2c60",
  null
  
)

export default component.exports